export default __webpack_public_path__ + "src/images/packages/zannier-hotels-omaanda/b31ee15cb7b916df7c3485e290d188e5-4.jpg";